/**
 * Utility class to manage correlation IDs for API calls
 * Generates and manages UUIDs for tracking related API calls
 */
class CorrelationIdManager {
  static generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /**
   * Generate a new correlation ID for a trip session
   * @returns {string} UUID string
   */
  static generateTripCorrelationId() {
    return this.generateUUID();
  }

  /**
   * Generate a new correlation ID for pickup location searches
   * @returns {string} UUID string
   */
  static generatePickupCorrelationId() {
    return this.generateUUID();
  }

  /**
   * Generate a new correlation ID for drop location searches
   * @returns {string} UUID string
   */
  static generateDropCorrelationId() {
    return this.generateUUID();
  }
}

export default CorrelationIdManager;
